export default (el, className, maxDepth = 3) => {
	if (!el) return null;
	let i = 0;
	while ((el = el.parentElement) && !el.classList.contains(className)) {
		// console.log('-', i, el, el.classList.contains(className));
		if (++i >= maxDepth && !el.classList.contains(className)) {
			el = null;
			break;
		}
	}
	// console.log('findAncestor:', el, ', iterations:', i);
	return el;
};
